<template>
  <div>
    <h1>{{ infractionDate }}</h1>
  </div>
</template>

<script>
export default {
  data() {
    return {
      infractionDate: "0000-00-00",
      holidays: [
        "2020-01-01",
        "2020-02-17",
        "2020-04-10",
        "2020-04-13",
        "2020-05-18",
        "2020-07-01",
        "2020-08-03",
        "2020-09-07",
        "2020-10-12",
        "2020-11-11",
        "2020-12-25",
        "2020-12-28",
        "2021-01-01",
        "2021-02-15",
        "2021-04-02",
        "2021-04-05",
        "2021-05-24",
        "2021-07-01",
        "2021-08-02",
        "2021-09-06",
        "2021-10-11",
        "2021-11-11",
        "2021-12-25",
        "2021-12-26",
        "2022-01-01",
        "2022-02-21",
        "2022-04-15",
        "2022-05-23",
        "2022-07-01",
        "2022-08-01",
        "2022-09-05",
        "2022-10-10",
        "2022-11-11",
        "2022-12-25",
        "2022-12-26"
      ]
    };
  },

  created() {
    // Calculate today + 45 days
    let day45 = new Date(new Date().getTime() + 45 * 24 * 60 * 60 * 1000);

    let done = false;
    while (!done) {
      // If it lands on a weekend, go to the next business day
      if (day45.getDay() == 6) {
        day45.setDate(day45.getDate() + 2);
      } else if (day45.getDay() == 0) {
        day45.setDate(day45.getDate() + 1);
      }

      // If the business day is a holiday, go to the next day
      let formated45 = this.formatDate(day45);
      if (this.holidays.includes(formated45)) {
        day45.setDate(day45.getDate() + 1);
      } else {
        this.infractionDate = formated45;
        done = true;
      }
    }
  },

  methods: {
    formatDate(date) {
      let d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;

      return [year, month, day].join("-");
    }
  }
};
</script>
